import * as React from "react"
import {optHtmlContent, renderDynamicContent} from "../../Utilities/CmsUtilities";

import {CmsContent} from "../../Model/CmsContent/CmsContent";
import {COUNTER_PAGE_LOAD} from "../../Service/CounterMetricsProvider";
import HeaderFooterWrapper from "../../Components/Navigation/HeaderFooterWrapper";

interface MaintenancePageProps {
    /**
     * Array of all content currently stored in the CMS that has been made available to the Sales Portal.
     */
    readonly cmsContent: CmsContent[];
}

const MaintenancePage: React.FC<MaintenancePageProps> = (props) => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        COUNTER_PAGE_LOAD.emit({
            severityNumber: 9,
            severityText: "INFO",
            body: "",
            attributes: {"page": "/maintenance"}
        });
    }, []);

    // Get branded maintenance HTML content
    const brandedHtml = optHtmlContent(props.cmsContent, "sp-page-maintenance");

    if (brandedHtml) {
        return (
            <HeaderFooterWrapper cmsContent={props.cmsContent}>
                {renderDynamicContent(brandedHtml)}
            </HeaderFooterWrapper>
        );
    }

    // Fallback: Render current maintenance UI
    return (
        <HeaderFooterWrapper cmsContent={props.cmsContent}>
            <div style={{ textAlign: "center", marginTop: "20vh" }}>
                <h1>Site is under maintenance</h1>
                <p>Please come back later.</p>
            </div>
        </HeaderFooterWrapper>
    );
};

export default MaintenancePage
